import { ACTION_TYPES } from "../../actions/notifications/NotificationsActions"

const initialState = {
    list: [],
    NotificationStatus : { },
    Notifications: []
}

export const NotificationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.FETCH_NOTIFICATIONDETAIL:
            return {
                ...state,
                Notifications: [...action.payload]
            }
        case ACTION_TYPES.FETCH_NOTIFICATIONSTATUS:
            return {
                ...state,
                NotificationStatus: action.payload
            }
        case  ACTION_TYPES.FETCH_NOTIFICATIONCHNGSTATUS:
            return{
                ...state
            }
        default:{            return state
        }
    }
}